import { ReactNode } from 'react';

interface CosmosWaveLayoutProps {
  children: ReactNode;
}

export function CosmosWaveLayout({ children }: CosmosWaveLayoutProps) {
  return (
    <div className="cw-theme min-h-screen">
      {children}
    </div>
  );
}